const MESSAGES = [
  "Scanning the AI universe",
  "Mapping orientations",
  "Analyzing patterns",
  "Computing consciousness",
  "Traversing galaxies",
  "Connecting constellations",
  "Reading the data pulse",
  "Measuring what matters",
];

export const ObservatoryLoader = ({ message, size = "md" }) => {
  const msg = message || MESSAGES[Math.floor(Math.random() * MESSAGES.length)];
  const s = size === "sm" ? { ring: 24, stroke: 2, text: "text-[10px]", gap: 2 } :
            size === "lg" ? { ring: 48, stroke: 3, text: "text-sm", gap: 4 } :
                            { ring: 32, stroke: 2.5, text: "text-xs", gap: 3 };

  return (
    <div className={`flex flex-col items-center justify-center py-8 gap-${s.gap}`} data-testid="observatory-loader">
      <div className="relative" style={{ width: s.ring, height: s.ring }}>
        <svg width={s.ring} height={s.ring} viewBox={`0 0 ${s.ring} ${s.ring}`} className="animate-spin" style={{ animationDuration: "1.5s" }}>
          <circle cx={s.ring/2} cy={s.ring/2} r={s.ring/2 - 4} fill="none" stroke="rgba(139,92,246,0.15)" strokeWidth={s.stroke} />
          <circle cx={s.ring/2} cy={s.ring/2} r={s.ring/2 - 4} fill="none" stroke="#8b5cf6" strokeWidth={s.stroke}
            strokeDasharray={`${(s.ring - 8) * Math.PI * 0.3} ${(s.ring - 8) * Math.PI * 0.7}`}
            strokeLinecap="round" />
        </svg>
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-1.5 h-1.5 rounded-full bg-violet-400" style={{ boxShadow: "0 0 6px rgba(139,92,246,0.6)" }} />
        </div>
      </div>
      <p className={`${s.text} text-slate-400 animate-pulse`}>{msg}</p>
    </div>
  );
};
